import startCase from 'lodash/startCase';

import { RolodexRecordStatus } from '../../../../../../graphql';

const relationshipStatusValues: RolodexRecordStatus[] = Object.values(RolodexRecordStatus);
export const relationshipStatusOptions: { label: string; value: RolodexRecordStatus }[] =
  relationshipStatusValues.map(value => ({
    value,
    label: startCase(value.toLowerCase()),
  }));
